// extracted by mini-css-extract-plugin
module.exports = {"invoices":"InvoicesHome_invoices__1GXeO","invoicesCol":"InvoicesHome_invoicesCol__2MQxb","invoicesColTitle":"InvoicesHome_invoicesColTitle__13yUL"};